import React, { Component, useState, useEffect } from 'react';

import { BrowserRouter as Router, Route, Switch, NavLink, Link, Redirect, withRouter } from "react-router-dom";

import validator from 'validator'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import jwt_decode from 'jwt-decode';
import { useAuth, useAutoSignin, withAuth, hasAuthParams } from "react-oidc-context";
import {
  Button,
  Menu,
  Dimmer,
  Loader
} from "semantic-ui-react";

import Permissions from './permissions/Permissions'
// import Status from './Status'
import Users from './users/Users'
import Games from './games/Games'
// import Swagger from './Swagger'
import Dashboard from './dashboard/Dashboard'

import logo from './assets/logo.svg';

// import "semantic-ui-css/semantic.min.css";
import './styles/App.css';

const NoMatch = ({ location }) => (
  <div>
    <h3>No match for <code>{location.pathname}</code></h3>
  </div>
)

const fakeAuth = {
  isAuthenticated: localStorage.getItem('apikey') ? true : false,
  authenticate(apikey, token, cb) {
    localStorage.setItem('jwt', token)
    localStorage.setItem('apikey', apikey)
    this.isAuthenticated = true
    setTimeout(cb, 100)
    // fetch('/api/admin/login', {
    //   accept: 'application/json',
    // })
    // .then(response => response.json())
    // .then(res => {
    //   console.log(res)
    //   localStorage.setItem('apikey', res.apikey)
    //   this.isAuthenticated = true
    //   cb()
    // })

  },
  signout(cb) {
    localStorage.clear()
    this.isAuthenticated = false
    fetch('/api/admin/logout') // Destroy session.
    setTimeout(cb, 100)
  }
}

function PrivateRoute({ component: Component, ...rest }) {
  let isAuthorized = false
  // Map token.permissions to rest.path to check access.
  if (fakeAuth.isAuthenticated) {
    let token = localStorage.getItem('jwt')
    try {
      token = jwt_decode(token)
    } catch (e) {
      fakeAuth.signout(() => {})
      console.log('Invalid token', e.message)
      return LoginRedirect(rest)
    }

    // @TODO Should we check expired token in another place?
    const timestamp = Math.floor(Date.now() / 1000)
    if (token.exp < timestamp) {
      fakeAuth.signout(() => {})
      toast.error('Your session has expired.')
      return LoginRedirect(rest)
    }

    const currentPath = rest.path.substring(1)
    if (rest.path === '/' && token.scopes.includes('dashboard')) {
      isAuthorized = true
    }
    else if (token.scopes.includes(currentPath)) {
      isAuthorized = true
    }
  }
  else {
    return LoginRedirect(rest)
  }

  if (isAuthorized === false) {
    toast.error('You are not authorized to view this page.')
    return null
  }

  return (
    <Route {...rest} render={(props) => (
      <Component {...props} />
    )} />
  )
}

const LoginRedirect = (rest) => {
  return <Route {...rest} render={(props) => (
    <Redirect to={{
      pathname: '/login',
      state: { from: props.location }
    }} />
  )} />
}

function App() {
  const auth = useAuth();
  const [hasTriedSignin, setHasTriedSignin] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false)
  const [scope, setScope] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  toast.configure({
    autoClose: 10000,
    position: toast.POSITION.BOTTOM_RIGHT
  })

  const handleMenuToggle = () => {
    setMobileMenu(!mobileMenu)
  }

  const checkLinkAccess = (link) => {
    // let token = localStorage.getItem('jwt')
    try {
      // token = jwt_decode(token)
      return ((link === '/' && scope.includes('dashboard')) || scope.includes(link)) ? true : false
    } catch (e) {
      console.log('Invalid token', e.message)
      return false
    }
  }

  // automatically sign-in
  useEffect(() => {
    if (!hasAuthParams() &&
      !auth.isAuthenticated && !auth.activeNavigator && !auth.isLoading &&
      !hasTriedSignin
    ) {
      auth.signinRedirect();
      setHasTriedSignin(true);
    }
  }, [auth, hasTriedSignin]);

  useEffect(() => {
    (async () => {
      try {
        if (auth.isAuthenticated && auth.user?.access_token) {
          // Call server to create session for Agendash
          const response = await fetch('/api/auth/session', {
            method: 'POST',
            credentials: 'include', // important for setting cookies
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${auth.user.access_token}`,
            },
          })
  
          if (response.ok) {
            console.log('Session established');
            
            setScope(await response.json())
            setIsLoading(false)

          } else {
            console.error('Failed to establish session', response.status);
          }
        }
      } catch (error) {
        console.error('Error calling /auth/session', error);
      }
    })()
  }, [auth.isAuthenticated, auth.user]);

  if (!auth.isAuthenticated) {
    // return <div>Unable to log in</div>;
    return <div></div>;
  }

  return (
    <Router>
      <Dimmer inverted className={(auth.isLoading || isLoading) ? 'active' : ''}>
        <Loader size='large' content='Loading'></Loader>
      </Dimmer>
      <Menu stackable inverted fixed='top' size='small' style={{zIndex: 1001}}>
        {/* <Container> */}
          <div className={`menu-icon ${mobileMenu ? 'open': ''}` } onClick={handleMenuToggle}>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <Menu.Item link header className={mobileMenu ? 'link-open': ''}>
            <Link to={'/'}>
              <img src={logo} className="App-logo" alt="logo" />
            </Link>
          </Menu.Item>
          {checkLinkAccess('games') &&
            <Menu.Item as={NavLink} to='/games' className={mobileMenu ? 'link-open': ''}>Games</Menu.Item>
          }
          {checkLinkAccess('users') &&
            <Menu.Item as={NavLink} to='/users' className={mobileMenu ? 'link-open': ''}>Users</Menu.Item>
          }
          {checkLinkAccess('permissions') &&
            <Menu.Item as={NavLink} to='/permissions' className={mobileMenu ? 'link-open': ''}>Permissions</Menu.Item>
          }
          {checkLinkAccess('dash') &&
            <Menu.Item href='/dash' target='_blank' className={mobileMenu ? 'link-open': ''}>
                Agenda MQ
            </Menu.Item>
          }
          <Menu.Item position='right' className={mobileMenu ? 'link-open': ''}>
            {auth.user.profile.name}
            <Button size='small' onClick={async () => {
              try {
                await fetch('/api/admin/logout', {
                  // method: 'POST',
                  // accept: 'application/json',
                  headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${auth.user.access_token}`
                  }
                })
          
                return auth.signoutRedirect()
              } catch (err) {
                console.error('Error during logout', err);
              }
            }}>Sign out</Button>
          </Menu.Item>
        {/* </Container> */}
      </Menu>

      <div id="page" className="page-content">
        <Switch>
          <Route path="/" exact component={Dashboard}/>
          <Route path="/games" exact component={Games}/>
          <Route path="/users" exact component={Users}/>
          <Route path="/permissions" component={Permissions}/>
          {/* <Route path="/docs" exact component={Swagger}/> */}
          {/* <Route path="/status" component={Status}/> */}
          <Route component={NoMatch}/>
        </Switch>
      </div>
    </Router>
  )
}

export default App;
